import { registerIVSQualityPlugin, registerIVSTech } from 'amazon-ivs-player'
import PropTypes from 'prop-types'
import { useContext, useMemo } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import StreamOffline from './StreamOffline'
import StreamOnline from './StreamOnline'
import StreamStarting from './StreamStarting'
import './vjs-moal.css'

registerIVSTech(videojs, {
  wasmWorker: '/amazon-ivs-wasmworker.min.js',
  wasmBinary: '/amazon-ivs-wasmworker.min.wasm'
})
registerIVSQualityPlugin(videojs)

const VideoSection = ({ modView }) => {
  const {
    [SETTINGS.VIDEO.key]: videos,
    [SETTINGS.PRE_STREAM.key]: preStreamSettings,
    [SETTINGS.LIVESTREAM_LIVE.key]: livestreamLive,
    [SETTINGS.STREAM_OFFLINE.key]: streamOffline,
    activeStreamer
  } = useContext(SiteConfigContext)

  const containerClass =
    'flex w-full sm:max-w-[640px] lg:max-w-[1024px] xl:max-w-[1280px] mx-auto aspect-video resize-helper'

  return useMemo(() => {
    const playbackUrl = activeStreamer?.IVSPlaybackURL
    const showPreStream = preStreamSettings?.enabled && videos?.prestream
    const showLiveStream = (livestreamLive || modView) && playbackUrl

    const renderContent = () => {
      if (showPreStream) {
        return (
          <StreamStarting
            videoURL={videos.prestream}
            startTime={preStreamSettings.startTime}
            videoDuration={preStreamSettings.videoDuration}
          />
        )
      }

      if (showLiveStream) {
        return <StreamOnline key={playbackUrl} IVSPlaybackURL={playbackUrl} />
      }

      return (
        <StreamOffline text={streamOffline?.text} link={streamOffline?.link} />
      )
    }

    return <div className={containerClass}>{renderContent()}</div>
  }, [preStreamSettings, livestreamLive, activeStreamer, streamOffline])
}

VideoSection.propTypes = {
  modView: PropTypes.bool
}

export default VideoSection
